module.exports = __webpack_public_path__ + "static/media/pilantropo_sc.dbd82ac5.jpg";